import React, { useState, useEffect } from "react";
import {
  Typography,
  Box,
  Button,
  Dialog,
  DialogContent,
  FormControlLabel,
  FormGroup,
  Checkbox,
  useMediaQuery,
  TextField,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { Field, getFormSyncErrors, getFormValues, reduxForm } from "redux-form";
import { connect } from "react-redux";
import { homeActions } from "actions";
import {
  renderTextField,
  renderSelectField,
  renderRadioField,
} from "components/FormFields/FieldTypes";
import { Required, emailValidator } from "components/FormFields/validators";
import { phone as phoneFormatter } from "components/FormFields/formatters";
import { phone as phoneValidator } from "components/FormFields/normalizers";

const RefillReminderPopUp = (props) => {
  const {
    showRefill,
    onCancel,
    reminderDates,
    getReminderDates,
    initialize,
    formErrors,
    brandDetailsNew,
    selectedInsurance,
    formValues,
    saveRefillReminder,
    savedRefillReminderInfo,
    profileInfo,
    genericDetails,
    selectedGenericItem,
    appQuantity,
    refillSavingsDetails,
    getRefillSavingsData,
    deleteCoupon,
    updateGTMDataLayer,
    resetSavedCouponInfo,
    resetDeleteCouponInfo,
  } = props;
  const [showSuccess, setShowSuccess] = useState(false);
  const [textNotification, setTextNotification] = useState(false);
  const [emailNotification, setEmailNotification] = useState(false);
  const [saveStarted, setSaveStarted] = useState(false);
  const [showFailure, setShowFailure] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);

  const matchesMinWidth = useMediaQuery("(max-width:600px)");

  const [emailValidate, setEmailValidate] = useState([emailValidator]);
  let customValidate = [emailValidator];

  const [startDate, setStartDate] = useState(null);

  useEffect(() => {
    getReminderDates();
    if (
      genericDetails &&
      genericDetails?.refillReminderFlag?.toLowerCase() === "y"
    ) {
      getRefillSavingsData(genericDetails?.productDetailId);
    }
    if (
      brandDetailsNew &&
      brandDetailsNew?.refillReminderFlag?.toLowerCase() === "y"
    ) {
      getRefillSavingsData(brandDetailsNew?.productDetailId);
    }
    updateGTMDataLayer({
      event: "Get_savings_refill_savings_attempt",
      action: "attempting coupon refill savings",
      page: "Copay Coupon Card",
      screen: "Copay Coupon Card",
      screen_referrer: "Copay Coupon Card",
      adjudicationId: brandDetailsNew?.id || genericDetails?.id,
    });
  }, []);

  useEffect(() => {
    const { data } = profileInfo;
    if (refillSavingsDetails) {
      if (profileInfo && Object.keys(profileInfo).length) {
        const { data } = profileInfo;
        setStartDate(refillSavingsDetails.startDate);
        initialize({
          email: data.email,
          duration: refillSavingsDetails.duration,
          // startDate: refillSavingsDetails.startDate,
          phone: data.phone,
        });
        data.email ? setEmailNotification(true) : setEmailNotification(false);
        data.phone ? setTextNotification(true) : setTextNotification(false);
      }
    } else {
      initialize({
        duration: 30,
        email: data?.email,
        phone: data?.phone,
      });
    }
  }, [refillSavingsDetails]);

  useEffect(() => {
    if (
      savedRefillReminderInfo &&
      savedRefillReminderInfo.success &&
      saveStarted
    ) {
      setShowSuccess(true);
      setShowFailure(false);
      setSaveStarted(false);
    } else if (
      savedRefillReminderInfo &&
      Object.keys(savedRefillReminderInfo).length &&
      savedRefillReminderInfo.success === false &&
      saveStarted
    ) {
      setShowSuccess(false);
      setShowFailure(true);
      setSaveStarted(false);
    }
  }, [savedRefillReminderInfo]);

  const onSubmitRefill = () => {
    const appData = JSON.parse(sessionStorage.getItem("applicationData"));
    const params = {
      duration: formValues["duration"],
      startDate: startDate,
      insuranceId: selectedInsurance.id,
      quantity: appQuantity || 0,
      productDetailId:
        brandDetailsNew?.productDetailId || genericDetails?.productDetailId,
      textNotification: textNotification,
      emailNotification: emailNotification,
      pharmacyLocationId: selectedGenericItem
        ? selectedGenericItem?.pharmacyLocationId
        : -1,
      couponType:
        selectedGenericItem?.couponType || selectedGenericItem?.discountType,
      deviceId: appData?.device?.id,
      appUserId: appData?.appUser?.id,
      id: refillSavingsDetails?.id || null,
    };
    setSaveStarted(true);
    saveRefillReminder(params);
    resetDeleteCouponInfo();
    updateGTMDataLayer({
      event: "Get_savings_refill_savings",
      page: "Copay Coupon Card",
      screen: "Copay Coupon Card",
      screen_referrer: "Copay Coupon Card",
      ...params,
      action: "compelted coupon refill savings",
    });
  };

  const onDeleteOptionClick = () => {
    setShowDeleteConfirm(true);
    setShowSuccess(false);
  };

  const onDelteCoupon = () => {
    setShowDeleteConfirm(false);
    setShowSuccess(false);
    onCancel();
    deleteCoupon(savedRefillReminderInfo?.data?.savedCouponId);
    resetSavedCouponInfo();
  };

  return (
    <>
      <Dialog open={showRefill} className="app-dialog">
        <DialogContent
          sx={{
            padding: "40px",
            width: matchesMinWidth ? undefined : "500px",
            textAlign: "center",
          }}
        >
          <Box sx={{ textAlign: "left" }}>
            {!showSuccess && !showFailure && !showDeleteConfirm ? (
              <Box>
                <form>
                  <Box mb={2}>
                    <Typography variant="h3LatoRegular">
                      Send me refill savings reminders every
                    </Typography>
                  </Box>
                  <Box mb={3}>
                    <Field
                      name="duration"
                      component={renderRadioField}
                      isRequired
                      validate={Required}
                      customLabel={<Box></Box>}
                      options={[
                        { id: "2", value: 30, text: "30 days" },
                        { id: "3", value: 90, text: "90 days" },
                      ]}
                    />
                  </Box>
                  <Box>
                    <Typography variant="h3LatoRegular">
                      I am starting my prescription on
                    </Typography>
                  </Box>
                  <Box mb={4}>
                    {/* <Field
                      name="startDate"
                      component={renderSelectField}
                      label=""
                      validate={Required}
                      options={reminderDates}
                    /> */}
                    <LocalizationProvider dateAdapter={AdapterMoment}>
                      <DatePicker
                        name="startDate"
                        value={startDate}
                        component={renderSelectField}
                        onChange={(newValue) => {
                          let date = new Date(newValue);
                          setStartDate(
                            `${
                              date.getMonth() + 1 < 10
                                ? "0" + (date.getMonth() + 1)
                                : date.getMonth() + 1
                            }/${date.getDate()}/${date.getFullYear()}`
                          );
                        }}
                        shouldDisableDate={(day) => {
                          let dateFormat = day.format("MM/DD/YYYY");
                          let filterDate = reminderDates.filter(
                            (item) => item.value === dateFormat
                          );
                          return filterDate.length ? false : true;
                        }}
                        renderInput={(inputProps) => {
                          return <TextField {...inputProps} />;
                        }}
                      />
                    </LocalizationProvider>
                  </Box>
                  <Box mb={2}>
                    <Typography variant="h3LatoRegular">send via</Typography>
                  </Box>
                  <Box mb={2}>
                    <FormGroup>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={textNotification}
                            onChange={() => {
                              setTextNotification(!textNotification);
                            }}
                            sx={{
                              "& .MuiSvgIcon-root": {
                                fontSize: "24px",
                                color: textNotification ? "#03952a" : "#607277",
                              },
                            }}
                          />
                        }
                        sx={{
                          "& .MuiFormControlLabel-label": {
                            color: textNotification ? "#003d4c" : "#607277",
                          },
                        }}
                        label="Text"
                      />
                    </FormGroup>
                    <Field
                      name="phone"
                      component={renderTextField}
                      label=""
                      validate={textNotification ? Required : ""}
                      format={phoneFormatter}
                      normalize={phoneValidator}
                    />
                  </Box>
                  <Box mb={6}>
                    <FormGroup>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={emailNotification}
                            onChange={() => {
                              if (!emailNotification) {
                                customValidate.push(Required);
                                setEmailValidate(customValidate);
                              } else {
                                customValidate = [emailValidator];
                                setEmailValidate([emailValidator]);
                              }
                              setEmailNotification(!emailNotification);
                            }}
                            sx={{
                              "& .MuiSvgIcon-root": {
                                fontSize: "24px",
                                color: emailNotification
                                  ? "#03952a"
                                  : "#607277",
                              },
                            }}
                          />
                        }
                        sx={{
                          "& .MuiFormControlLabel-label": {
                            color: emailNotification ? "#003d4c" : "#607277",
                          },
                        }}
                        label="Email Address"
                      />
                      <Field
                        name="email"
                        label=""
                        component={renderTextField}
                        disabled={!emailNotification}
                        validate={emailNotification ? emailValidate : ""}
                      />
                    </FormGroup>
                  </Box>
                  <Box mb={4} sx={{ textAlign: "center", width: "100%" }}>
                    <Button
                      variant="large"
                      disabled={
                        Object.keys(formErrors).length ||
                        (!textNotification && !emailNotification)
                          ? true
                          : false
                      }
                      onClick={onSubmitRefill}
                      sx={{
                        fontSize: matchesMinWidth ? "14px" : undefined,
                        minWidth: matchesMinWidth ? "200px" : undefined,
                        backgroundColor:
                          formErrors && Object.keys(formErrors).length
                            ? "#e6e6e6"
                            : undefined,
                      }}
                    >
                      SAVE REFILL SAVINGS
                    </Button>
                  </Box>
                  <Box mx="auto" sx={{ textAlign: "center" }}>
                    <Button
                      variant="text"
                      sx={{
                        minWidth: matchesMinWidth ? "200px" : undefined,
                        textDecoration: "underline",
                        fontSize: matchesMinWidth ? "16px" : undefined,
                      }}
                      onClick={onCancel}
                    >
                      CANCEL
                    </Button>
                  </Box>
                </form>
              </Box>
            ) : (
              <Box sx={{ textAlign: "center" }}>
                {showSuccess ? (
                  <Box>
                    <Box mb={4}>
                      <Typography
                        variant="h2LatoBlack"
                        sx={{ fontSize: "25px" }}
                      >
                        CONFIRMED
                      </Typography>
                    </Box>
                    <Box mb={1}>
                      <Typography variant="h1LatoMedium">
                        We will send you refill savings reminders every:
                      </Typography>
                    </Box>
                    <Box mb={5}>
                      <Typography variant="h3LatoBlack">
                        {formValues.duration} days
                      </Typography>
                    </Box>
                    <Box mb={1}>
                      <Typography variant="h1LatoMedium">via:</Typography>
                    </Box>
                    <Box mb={8}>
                      <Typography variant="h3LatoBlack">
                        {phoneFormatter(formValues?.phone)}
                      </Typography>
                      <br />
                      <Typography variant="h3LatoBlack">
                        {formValues?.email}
                      </Typography>
                    </Box>
                    <Box mb={4}>
                      <Button
                        variant="large"
                        sx={{ minWidth: matchesMinWidth ? "200px" : undefined }}
                        onClick={() => {
                          setShowSuccess(false);
                          onCancel();
                        }}
                      >
                        DONE
                      </Button>
                    </Box>
                    <Box mt={2} mx="auto">
                      <Button
                        variant="text"
                        sx={{
                          textDecoration: "underline",
                          minWidth: matchesMinWidth ? "200px" : undefined,
                          fontSize: matchesMinWidth ? "16px" : undefined,
                        }}
                        onClick={onDeleteOptionClick}
                      >
                        DELETE REFILL SAVINGS
                      </Button>
                    </Box>
                  </Box>
                ) : null}
                {showFailure ? (
                  <Box>
                    <Box>
                      <Typography variant="text2" sx={{ fontSize: "25px" }}>
                        Refill Reminder Error
                      </Typography>
                    </Box>
                    <Box my={4}>
                      <Typography variant="text3">
                        {savedRefillReminderInfo.message}
                      </Typography>
                    </Box>
                    <Box>
                      <Button
                        sx={{ minWidth: matchesMinWidth ? "200px" : undefined }}
                        variant="large"
                        onClick={() => setShowFailure(false)}
                      >
                        DONE
                      </Button>
                    </Box>
                  </Box>
                ) : null}
                {showDeleteConfirm ? (
                  <Box>
                    <Box>
                      <Typography variant="h2LatoRegular">
                        Are you sure do you want to delete?
                      </Typography>
                    </Box>
                    <Box mb={2} mt={4}>
                      <Button
                        sx={{ minWidth: matchesMinWidth ? "200px" : undefined }}
                        variant="large"
                        onClick={onDelteCoupon}
                      >
                        DONE
                      </Button>
                    </Box>
                    <Box>
                      <Button
                        variant="text"
                        sx={{ minWidth: matchesMinWidth ? "200px" : undefined }}
                        onClick={() => {
                          setShowDeleteConfirm(false);
                          setShowSuccess(true);
                        }}
                      >
                        Cancel
                      </Button>
                    </Box>
                  </Box>
                ) : null}
              </Box>
            )}
          </Box>
        </DialogContent>
      </Dialog>
    </>
  );
};

function mapStateToProps(state) {
  return {
    reminderDates: state.reminderDates.data,
    formErrors: getFormSyncErrors("REFILL_REMINDER_FORM")(state) || {},
    formValues: getFormValues("REFILL_REMINDER_FORM")(state),
    brandDetailsNew: state.brandDetailsNew.data || {},
    selectedInsurance: state.insuranceList.selectedInsurance || {},
    selectedProduct: state.home.selectedProduct,
    genericDetails: state.genericDetails.data,
    productDetailId: state.productDetails.productDetailId,
    profileInfo: state.profile.profileData,
    savedDoseReminderInfo: state.savedDoseReminderInfo.data,
    zipData: state.zipData.data,
    couponData: state.couponPrice.data,
    savedRefillReminderInfo: state.savedRefillReminderInfo.data,
    appQuantity: state.productDetails.appQuantity,
    refillSavingsDetails: state.refillSavingsDetails.data,
  };
}

const mapDispatchToProps = {
  getReminderDates: (params) => homeActions.getReminderDates(params),
  saveRefillReminder: (params) => homeActions.saveRefillReminder(params),
  getRefillSavingsData: (params) => homeActions.getRefillSavingsData(params),
  deleteCoupon: (value) => homeActions.deleteCoupon(value),
  updateGTMDataLayer: (param) => homeActions.updateGTMDataLayer(param),
  resetSavedCouponInfo: (value) => homeActions.resetSavedCouponInfo(value),
  resetDeleteCouponInfo: () => homeActions.resetDeleteCouponInfo(),
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  reduxForm({
    form: "REFILL_REMINDER_FORM",
  })(RefillReminderPopUp)
);
